
import React from 'react';
import makeStyles                                  from '@material-ui/core/styles/makeStyles';
import {Trans, useTranslation} from 'react-i18next';
import { darken, lighten }                         from '@material-ui/core/styles';
import Paper                                       from '@material-ui/core/Paper';
import Grid                                        from '@material-ui/core/Grid';
import {Typography} from '@material-ui/core';
import Button from '../../core/input/Button';
import AssistantIcon from '@material-ui/icons/Assistant';

const useStyles = makeStyles(theme => {
	// based on https://github.com/mui-org/material-ui/blob/master/packages/material-ui-lab/src/Alert/Alert.js
	const getColor = theme.palette.type === 'light' ? darken : lighten;
	const getBackgroundColor = theme.palette.type === 'light' ? lighten : darken;

	return {
		root: {
			padding: theme.spacing(3),
			justifyContent: 'center',
			color: getColor(theme.palette.warning.main, 0.6),
			backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
		},
	};
});

const ShellsNotice = () => {
	const classes = useStyles();
	const {t} = useTranslation();

	const info = [
		{
			key:'shells_ia_notice',
			action:<Button
				component='a'
				startIcon={<AssistantIcon/>}
				href={'https://www.shells.com/ai'}
				variant='contained'
				color='primary'
				target='_blank'
			>
				{t('learn_more_here_btn')}
			</Button>
		}
	];


	return (
		<Paper elevation={0} className={classes.root}>
			<Grid container spacing={2} alignItems='center' justifyContent='center' direction='column'>
				<Grid item>
					<div>
						{info.map(w =>
							<Grid container spacing={8} key={w.key} alignItems={'center'} justifyContent='space-between'>
								<Grid item>
									<Typography variant='body1'>
										<Trans
											i18nKey={w.key}
										>
											sample<br/>
											<strong>sample</strong>
										</Trans>
									</Typography>
								</Grid>
								{w.action && <Grid item>{w.action}</Grid>}
							</Grid>
						)}

					</div>
				</Grid>
			</Grid>

		</Paper>);
};

export default ShellsNotice;
